import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePortalAuth } from "../lib/portalAuth";

// role: "admin" requires an admin user; otherwise any authenticated user is allowed.
export default function PortalProtectedRoute({ children, role }) {
  const { user } = usePortalAuth();
  const { pathname } = useLocation();
  // Admin routes send unauthenticated visitors to the admin login; the client
  // portal sends them to the client login.
  const loginPath = pathname.startsWith("/admin") ? "/admin/login" : "/portal/login";

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-ink-muted">
        <Loader2 className="w-5 h-5 animate-spin mr-2" /> Checking session
      </div>
    );
  }

  if (!user) {
    return <Navigate to={loginPath} replace />;
  }

  if (role === "admin" && user.role !== "admin") {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
